import { Fetcher } from "@/utils/fetcher";

const ads = new Fetcher("ads-modules");

ads.setUseToken(false);

export const getFilterAds = (params: {
  category_slug?: string;
  brand_slug?: string;
  product_slug?: string;
  isCheckout?: boolean;
}) => ads.post<AdsFilterResponse>("/storefront/filter", params);
